export enum PaymentPlan {
  BRONZE = 'BRONZE',
  SILVER = 'SILVER',
  GOLD = 'GOLD',
  PLATINUM = 'PLATINUM',
  STARTER = 'STARTER',
  BASIC = 'BASIC',
  GROWTH = 'GROWTH',
  STARTER_PRO="STARTER_PRO",
  BUSINESS_ELITE="BUSINESS_ELITE",
  RECEPTIONIST_ENTREPRISE="RECEPTIONIST_ENTREPRISE",
  ENTREPRISE = 'ENTREPRISE',
  WHITELABEL = 'WHITELABEL',
  DISCOUNTED = 'DISCOUNTED',
  PHONE_NUMBER = 'PHONE_NUMBER'
}